//
//
//
//
//
//
//

let canvas, ctx
import {
  mapState
} from 'vuex'
import {
  clearInterval
} from 'timers';
export default {
  name: "v-watermark",
  data() {
    return {
      img: ''
    }
  },
  props: {
    target: {
      type: String,
      default: ""
    },

    row: {
      type: Number,
      default: 0
    },
    column: {
      type: Number,
      default: 0
    },
    itemWidth: {
      type: Number,
      default: 50
    },
    itemHeight: {
      type: Number,
      default: 50
    },
    text: {
      type: String,
      default: "data"
    },
    angle: {
      type: Number,
      default: -15
    },
    xStart: {
      type: Number,
      default: 0
    },
    yStart: {
      type: Number,
      default: 0
    },
    xSpace: {
      type: Number,
      default: 10,
      validator: value => value >= 0
    },
    ySpace: {
      type: Number,
      default: 10,
      validator: value => value >= 0
    },
    fontSize: {
      type: String,
      default: "16px"
    },
    font: {
      type: String,
      default: "微软雅黑"
    },
    color: {
      type: String,
      default: "#000000",
      validator: value => /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/.test(value)
    },
    alpha: {
      type: Number,
      default: 0.1,
      validator: value => value >= 0 && value <= 1
    },
  },
  computed: {
    _row: function () {
      return this.row ?
        this.row :
        this.contentHeight - this.yStart ?
        Math.ceil((this.contentHeight - this.yStart) / this.yTotal) :
        1
    },
    _column: function () {
      return this.column ?
        this.column :
        this.contentWidth - this.xStart ?
        Math.ceil((this.contentWidth - this.xStart) / this.xTotal) :
        1
    },
    rowInt: function () {
      return this._row >= 1 ? Math.floor(Number(this._row)) : 1
    },
    columnInt: function () {
      return this._column >= 1 ? Math.floor(Number(this._column)) : 1
    },
    xTotal: function () {
      return this.xSpace + this.itemWidth
    },
    yTotal: function () {
      return this.ySpace + this.itemHeight
    },
    contentWidth: function () {
      const wrapper = this.$refs["wrapper"]
      return this.wmWidth
      // return wrapper.width || wrapper.scrollWidth || wrapper.clientWidth;
    },
    contentHeight: function () {
      return this.wmHeight
      // return wrapper.height || wrapper.scrollHeight || wrapper.clientHeight;
    }
  },
  watch: {
    text(newval, oldval) {
      if (newval) {
        this.drawWaterMark(newval)
      }
    }
  },
  methods: {
    drawWaterMark(name) {
      ctx.fillText(this.text, 0, 0);
      ctx.restore();
      // ctx.fillStyle = 'red';
      // ctx.fillRect(x, y, 2, 2);
      this.$nextTick(() => {
        this.img = ctx.canvas.toDataURL()
      })

    }
  },
  mounted() {
    let x =50,
      y = 50;
    let lineHeight = 30;
    canvas = this.$refs.canvas;
    ctx = canvas.getContext('2d');
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(-Math.PI / 4);
    ctx.textAlign = "center"
    ctx.fillStyle = "rgba(0,0,0,0.1)";
    ctx.font = "16px Microsoft YaHei";


  },
  beforeDestroy() {
    //clearInterval(intval)
  }
}




// WEBPACK FOOTER //
// ./src/components/watermark.vue